/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  notes: 'Notes',
  note: 'Note',
  saved: 'Saved',
  pin: 'Pin',
  unpin: 'Unpin',
  unpinFailure: 'Note could not be unpinned.',
  download: 'Download',
  share: 'Share',
  shareSuccess: 'Note shared successfully.',
  shareFailure: 'Note could not be shared.',
  delete: 'Delete',
  deletePrompt: 'Are you sure that you want to delete this note?',
  search: 'Search',
  syncFailure: 'Notes could not be synced.',
  filter: 'Filter',
  keyword: 'Keyword',
  newNote: 'New Note',
  add: 'Add',
  created: 'Created',
  modified: 'Modified',
  selectNote: 'Select A Note',
  selectNoteInformation: 'This panel will display useful information and actions once you select a note from the note list.',
  welcome: 'Welcome!',
  selectNoteOrCreate: 'Select a note or create a new one.',
  conflict: 'Conflict',
  syncingGotDisabled: 'The note synchronization got disabled due to unexpected errors.',
  notFoundOrNotSynced: 'The note was not found or is not synced yet.',
}
